var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0002 41L34.3335 44.3333L41.0002 37.6667M37.6668 21.0014C37.5077 21 37.329 21 37.1247 21H29.6672C27.8003 21 26.8662 21 26.1532 21.3633C25.526 21.6829 25.0164 22.1925 24.6968 22.8197C24.3335 23.5327 24.3335 24.4668 24.3335 26.3337V45.667C24.3335 47.5338 24.3335 48.4668 24.6968 49.1798C25.0164 49.807 25.526 50.3175 26.1532 50.637C26.8655 51 27.7985 51 29.6617 51L42.3386 51C44.2018 51 45.1335 51 45.8458 50.637C46.473 50.3175 46.9843 49.807 47.3039 49.1798C47.6668 48.4675 47.6668 47.5358 47.6668 45.6726V31.5428C47.6668 31.3383 47.6668 31.1593 47.6653 31M37.6668 21.0014C38.1429 21.0058 38.4441 21.0231 38.7316 21.0921C39.0717 21.1738 39.3966 21.3088 39.6948 21.4915C40.0311 21.6976 40.3199 21.9864 40.896 22.5625L46.1051 27.7716C46.6816 28.3481 46.9683 28.6356 47.1744 28.972C47.3572 29.2702 47.4924 29.5954 47.5741 29.9355C47.6431 30.2229 47.6607 30.5242 47.6653 31M37.6668 21.0014V25.6667C37.6668 27.5335 37.6668 28.4663 38.0301 29.1793C38.3497 29.8065 38.8593 30.3175 39.4865 30.637C40.1988 31 41.1318 31 42.995 31H47.6653M47.6653 31H47.6672",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.1e4480d4b38e69b97a0b807479db4c51.svg";
export { ForwardRef as ReactComponent };